<template>
    <v-autocomplete dense outlined hide-details="auto" return-object :filter="() => true" :label="label"
        :disabled="disabled" :items="items" item-text="address" item-value="address" :value="selected"
        :loading="loading" placeholder="Digite ao menos 3 caracteres" no-data-text="Nenhum endereço encontrado"
        :autofocus="autofocus" @update:search-input="search" @change="select">
        <template v-slot:item="{ item }">
            <div class="py-2">
                <span v-if="item.name" class="text-caption"><strong>{{ item.name }}</strong><br /></span>
                <span class="text-caption">{{ item.address }}</span>
            </div>
        </template>
        <template v-slot:selection="{ item }">
            <span class="text-body-2 text-truncate" :title="item.address">{{ item.address }}</span>
        </template>
    </v-autocomplete>
</template>

<script>
import axios from 'axios'

const newToken = () => (window.crypto && window.crypto.randomUUID)
    ? window.crypto.randomUUID()
    : `${Date.now()}${Math.random()}`

// Busca de endereço (Google via backend). Emite `select` com
// { coords: [lat, lng], address: { iid, address, city, state, district } }.
export default {
    name: 'AddressSearchField',
    props: {
        value: { type: Object, default: null },
        label: { type: String, default: 'Endereço' },
        disabled: { type: Boolean, default: false },
        autofocus: { type: Boolean, default: false }
    },
    data: () => ({
        results: [],
        loading: false,
        token: null,
        timer: null,
        controller: null
    }),
    computed: {
        selected() {
            return this.value && this.value.address ? this.value : null
        },
        items() {
            const list = [...this.results]
            if (this.selected && !list.some(item => item.address === this.selected.address)) list.unshift(this.selected)
            return list
        }
    },
    methods: {
        search(value) {
            clearTimeout(this.timer)

            if (!value || value.trim().length < 3 || (this.selected && value === this.selected.address)) return

            this.timer = setTimeout(() => this.runSearch(value), 500)
        },
        async runSearch(value) {
            if (!this.token) this.token = newToken()
            if (this.controller) this.controller.abort()

            this.controller = new AbortController()
            this.loading = true

            try {
                const response = await axios.get(`/api/v2/google-maps/find/${encodeURIComponent(value)}`, {
                    params: { sessiontoken: this.token },
                    signal: this.controller.signal
                })

                this.results = (response.data.content || []).map(item => ({
                    name: item.name,
                    address: item.address,
                    iid: item.placeId
                }))
            } catch (error) {
                if (!axios.isCancel(error)) console.error('Erro ao buscar endereço:', error)
            } finally {
                this.loading = false
            }
        },
        async select(item) {
            if (!item || !item.iid) return

            this.loading = true

            try {
                const response = await axios.get(`/api/v2/google-maps/place-details/${item.iid}`, {
                    params: this.token ? { sessiontoken: this.token } : {}
                })
                const details = response.data.content || {}

                this.token = null
                this.$emit('select', {
                    coords: [details.coordinates.lat, details.coordinates.lng],
                    address: {
                        iid: item.iid,
                        address: item.address,
                        city: details.city || null,
                        state: details.state || null,
                        district: details.district || null
                    }
                })
            } catch (error) {
                console.error('Erro ao buscar detalhes do endereço:', error)
                this.$emit('error', 'Não foi possível obter as coordenadas do endereço selecionado')
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
